import { push } from 'connected-react-router'
import React, { FC } from 'react'
import { useDispatch } from '../../../store'

interface LinkProps {
  linkTo: string
  text: string
  className?: string
}
const Link: FC<LinkProps> = ({ linkTo, text, className }) => {
  const dispatch = useDispatch()
  const onClick = () => dispatch(push(linkTo))
  return (
    <div className={`${className} block-link`} onClick={onClick}>
      {text}
    </div>
  )
}

export default Link
